var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 170,
  height: 122,
  rx: 21,
  fill: "white",
  stroke: "#0CCFCF",
  strokeWidth: 2
});
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 16,
  width: 139,
  height: 13,
  rx: 5,
  stroke: "#192E53",
  strokeWidth: 2
});
var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 35,
  width: 139,
  height: 47,
  rx: 9,
  stroke: "#192E53",
  strokeWidth: 2
});
var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 88,
  width: 67,
  height: 29,
  rx: 9,
  stroke: "#192E53",
  strokeWidth: 2
});
var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 89,
  y: 88,
  width: 66,
  height: 29,
  rx: 9,
  stroke: "#192E53",
  strokeWidth: 2
});
var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 117,
  y: 61,
  width: 48,
  height: 81,
  rx: 11,
  fill: "white",
  stroke: "#0CCFCF",
  strokeWidth: 2
});
var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 127,
  y: 68,
  width: 28,
  height: 13,
  rx: 3,
  stroke: "#192E53",
  strokeWidth: 2
});
var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 127,
  y: 87,
  width: 28,
  height: 47,
  rx: 5,
  stroke: "#192E53",
  strokeWidth: 2
});
function SvgTemplate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 143,
    viewBox: "0 0 172 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.e9485801d64344c8f30e963d874f0821.svg";
export { ForwardRef as ReactComponent };